export const isAccountantUser = (user) => {
  if (!user) {
    return false;
  }

  if (user.admin_id !== null && user.admin_id !== undefined) {
    return true;
  }

  return Number(user.access_right ?? 0) !== 0;
};

export const isMainOrganizationUser = (user) => {
  return !isAccountantUser(user);
};
